import React from "react";
import * as s from "./index.module.scss";
import Link from "next/link";
import { IoArrowForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";

const SimilarBlogs = ({ data }) => {
  return (
    <div className={s.similar_blog_grid}>
      {data.map(({ image, title, buttonLink }, idx) => {
        return (
          <Link href={buttonLink} key={idx}>
            <div
              key={idx}
              className={`col-12 col-md-4  p-0 mb-4 mb-md-0 ${s.single_similar_blog}`}
            >
              <img
                loading="lazy"
                src={image.url}
                alt={image.alt || "image"}
                height="100%"
              />
              <div className={s.blog}>
                <p className={`paragraph fw-bold mb-4 ${secondaryFont}`}>
                  {title}
                </p>
                <Link href={buttonLink} className={`${secondaryFont}`}>
                  See More{" "}
                  <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
                </Link>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default SimilarBlogs;
